import {
  clarityConfigSchema,
  ga4ConfigSchema,
  gtmConfigSchema,
  hotjarConfigSchema,
  klaviyoConfigSchema,
  metaConfigSchema,
  pinterestConfigSchema,
  redditConfigSchema,
  snapchatConfigSchema,
  tiktokConfigSchema,
} from "schemas/integration";

// NOTE (Max, 2025-07-31): Add an integration details here if you want it to be supported on our Integrations UI.
export const INTEGRATION_CONFIGS = {
  GA4: {
    schema: ga4ConfigSchema,
    title: "Google Analytics 4",
    value: "GA4",
    image: "/images/integration/logos/googleanalytics.png",
    description:
      "Track website traffic and user behavior with Google Analytics 4",
    fields: {
      integrationKey: {
        label: "Measurement ID",
        placeholder: "G-XXXXXXXXXX",
      },
    },
  },
  GoogleTagManager: {
    schema: gtmConfigSchema,
    title: "Google Tag Manager",
    value: "GoogleTagManager",
    image: "/images/integration/logos/googletagmanager.png",
    description:
      "Manage all your marketing tags in one place with Google Tag Manager",
    fields: {
      integrationKey: {
        label: "Container ID",
        placeholder: "GTM-XXXXXXX",
      },
    },
  },
  Hotjar: {
    schema: hotjarConfigSchema,
    title: "Hotjar",
    value: "Hotjar",
    image: "/images/integration/logos/hotjar.png",
    description:
      "Understand user behavior with heatmaps, recordings and feedback",
    fields: {
      integrationKey: {
        label: "Site ID",
        placeholder: "1234567",
      },
    },
  },
  Klaviyo: {
    schema: klaviyoConfigSchema,
    title: "Klaviyo",
    value: "Klaviyo",
    image: "/images/integration/logos/klaviyo.png",
    description:
      "Maximize ROI with email marketing, SMS & marketing automation",
    fields: {
      integrationKey: {
        label: "Public API Key",
        placeholder: "Enter your API key",
      },
    },
  },
  Meta: {
    schema: metaConfigSchema,
    title: "Meta Pixel",
    value: "Meta",
    image: "/images/integration/logos/meta.png",
    description:
      "Track conversions and build audiences for Meta advertising campaigns",
    fields: {
      integrationKey: {
        label: "Pixel ID",
        placeholder: "Enter your pixel ID",
      },
    },
  },
  MicrosoftClarity: {
    schema: clarityConfigSchema,
    title: "Microsoft Clarity",
    value: "MicrosoftClarity",
    image: "/images/integration/logos/microsoftclarity.png",
    description:
      "Free user behavior analytics with heatmaps and session recordings",
    fields: {
      integrationKey: {
        label: "Project ID",
        placeholder: "Enter your project ID",
      },
    },
  },
  Pinterest: {
    schema: pinterestConfigSchema,
    title: "Pinterest Tag",
    value: "Pinterest",
    image: "/images/integration/logos/pinterest.png",
    description: "Measure Pinterest ad performance and create custom audiences",
    fields: {
      integrationKey: {
        label: "Tag ID",
        placeholder: "Enter your tag ID",
      },
    },
  },
  Reddit: {
    schema: redditConfigSchema,
    title: "Reddit Pixel",
    value: "Reddit",
    image: "/images/integration/logos/reddit.png",
    description:
      "Track Reddit ad conversions and optimize campaign performance",
    fields: {
      integrationKey: {
        label: "Pixel ID",
        placeholder: "Enter your pixel ID",
      },
    },
  },
  Snapchat: {
    schema: snapchatConfigSchema,
    title: "Snapchat Pixel",
    value: "Snapchat",
    image: "/images/integration/logos/snapchat.png",
    description:
      "Track conversions and build audiences for Snapchat advertising",
    fields: {
      integrationKey: {
        label: "Pixel ID",
        placeholder: "Enter your pixel ID",
      },
    },
  },
  TikTok: {
    schema: tiktokConfigSchema,
    title: "TikTok Pixel",
    value: "TikTok",
    image: "/images/integration/logos/tiktok.png",
    description:
      "Optimize TikTok ads with conversion tracking and audience building",
    fields: {
      integrationKey: {
        label: "Pixel ID",
        placeholder: "Enter your pixel ID",
      },
    },
  },
  Triplewhale: {
    schema: tiktokConfigSchema, // Using same config for now, adjust if needed
    title: "Triplewhale",
    value: "Triplewhale",
    image: "/images/integration/logos/triplewhale.png",
    description: "E-commerce analytics and attribution platform",
    fields: {
      integrationKey: {
        label: "Pixel ID",
        placeholder: "Enter your pixel ID",
      },
    },
  },
} as const;
